import {
  AddHistoryAndIllnessActionTypes,
  GetPatientDemographicsState,
  ADD_HISTORY_AND_ILLNESS_SUCCESS,
  ADD_HISTORY_AND_ILLNESS_LOADING,
  ADD_HISTORY_AND_ILLNESS_FAIL,
} from "./ActionTypes";
import { HistoryAndIllnessResponse } from "./Model";

const initialStateGetPosts: GetPatientDemographicsState = {
  loading: false,
  historyandillnessDetails: {} as HistoryAndIllnessResponse,
};
export const addhistoryandIllnessReducer = (
  state = initialStateGetPosts,
  action: AddHistoryAndIllnessActionTypes
): GetPatientDemographicsState => {
  switch (action.type) {
    case ADD_HISTORY_AND_ILLNESS_SUCCESS:
      return {
        ...state,
        loading: false,
        historyandillnessDetails: action.payload,
      };
    case ADD_HISTORY_AND_ILLNESS_LOADING:
      return {
        ...state,
        loading: true,
        historyandillnessDetails: {} as HistoryAndIllnessResponse,
      };
    case ADD_HISTORY_AND_ILLNESS_FAIL:
      return {
        ...state,
        historyandillnessDetails: {} as HistoryAndIllnessResponse,
        loading: false,
      };
    default:
      return state;
  }
};
